/* Jquery match height */
$('.footer-list').matchHeight();
$('.feature').matchHeight();
$('.card').matchHeight();
$('.gallery-image').matchHeight();